<template>
  <BaseListItem>
    <div class="flex -mx-3 p-4">
      <div class="flex-1 px-3 capitalize">
        <RouterLink :to="to">
          {{ contactList.name }}
        </RouterLink>
      </div>
      <div class="flex-1 px-3 text-right">
        {{ contactList.active_subscriptions_count || 0 }}
      </div>
      <div class="w-48 px-3 text-right">
        <p>
          {{ dateCreatedAt }}
        </p>
        <span class="text-sm text-gray-600">
          {{ timeCreatedAt }}
        </span>
      </div>
    </div>
  </BaseListItem>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    contactList: {
      type: Object,
      required: true,
    },
  },
  computed: {
    to() {
      const { id: contactListId } = this.contactList;
      const { accountId } = this.$route.params;

      return {
        name: 'accounts.contactLists.contactListId',
        params: { accountId, contactListId },
      };
    },
    createdAt() {
      return moment(this.contactList.created_at);
    },
    dateCreatedAt() {
      return this.createdAt.format('DD-MM-YYYY');
    },
    timeCreatedAt() {
      return this.createdAt.format('HH:mm');
    },
  },
};
</script>
